<template>
	<div class="flex box start">
		<loader></loader>
		<div class="card nine-lg">
			<header class="card-header">
				<h3 class="card-title">Today Active Users</h3>
			</header>
			<div class="card-body">
				<div v-if="activeUsers" class="table-lister table-responsive">
					<table>
						<thead>
						<tr>
							<th>
								<span class="th">User</span>
							</th>
							<th>
								<span class="th">Events</span>
							</th>
						</tr>
						</thead>
						<tbody>
							<tr v-for="(auditLog, index) in activeUsers">
								<td><strong>{{ auditLog.userName }}</strong></td>
								<td>
									<div class="article-title audit-list" v-for="log in auditLog.logs">
										<span v-for="event in log.events" class="badge"
											  v-bind:class="{
												'badge-warning': event === 'updated',
												'badge-success': event === 'created',
												'badge-danger': event === 'deleted',
											}">{{ event }}</span>
										{{ log.type }}
										<ul v-for="(action, id) in log.actions" class="list">
											<li><strong>#{{ id }}</strong> {{ action.title }} <span style="float: right">{{ action.seconds }}</span></li>
										</ul>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<div class="card three-lg">
			<header class="card-header">
				<h3 class="card-title">Select date</h3>
			</header>
			<div class="card-body">
				<div class="form-group">
					<input name="dateFrom" type="date" v-model="dateFrom">
				</div>
				<div class="form-group">
					<button class="btn btn-md btn-success" @click="loadData()">Show data</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {eventBus} from "../../app";
import modal from '../Modal/DefaultModal.vue';

export default {
	name: "AuditsByUserLogsList",
	components: {
		modal
	},
	props: {
		dataActiveUsers: {
			type: Object
		},
		dataDateFrom: {
			type: String
		}
	},
	data() {
		return {
			activeUsers: this.dataActiveUsers,
			dateFrom: this.dataDateFrom,
		}
	},
	methods: {
		loadData: function () {
			let vm = this;

			let data = {
				'dateFrom': this.dateFrom
			}

			eventBus.$emit('onLoaderStart');
			axios.post('/api/audit/logs/user_data_by_date', data)
				.then(function (response) {
					if (response.data) {
						vm.activeUsers = response.data;
						eventBus.$emit('onLoaderFinish');
						vm.$toastr.success('Data loaded', 'Success');
					} // if
				})
				.catch(function (e) {
					eventBus.$emit('onLoaderFinish');
					vm.$toastr.error('Could not load the data.', 'Error');
				});
		}
	}
}
</script>

<style scoped>

</style>
